import {
  SAVE_PROJECT_TYPE,
  RESET_PROJECT,
  SET_SEGMENTS_ACCORDION_STATUS,
} from './action-types';

export const saveProjectType = (formValues) => async (dispatch) => {
  dispatch({
    type: SAVE_PROJECT_TYPE,
    payload: formValues,
  });
};

export const resetProject = () => async (dispatch) => {
  dispatch({
    type: RESET_PROJECT,
  });
};

export const segmentsAccordionStatus = (data) => async (dispatch) => {
  dispatch({
    type: SET_SEGMENTS_ACCORDION_STATUS,
    payload: data,
  });
};
